/** Mobile shell inspectors occupy a full screen with a leading return action. */
import type { ReactNode } from 'react';
import { ChevronLeft } from '../../shared/ui/icons';
import { Button } from '../../shared/ui/button';

export function MobileInspectorScreen({ open, onClose, children }: {
  open: boolean;
  onClose?: () => void;
  children: ReactNode;
}) {
  return (
    <section
      data-slot="app-mobile-right-panel"
      data-open={open}
      className="qs-shell-mobile-panel"
      hidden={!open}
      aria-label="Inspector"
    >
      {onClose && (
        <div className="shrink-0 px-4 py-2">
          <Button type="button" variant="ghost" size="icon" aria-label="Back to screen" onClick={onClose}>
            <ChevronLeft className="h-5 w-5" aria-hidden="true" />
          </Button>
        </div>
      )}
      <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
    </section>
  );
}
